import { render, staticRenderFns } from "./ThinFemale.vue?vue&type=template&id=2a2fe5ac&scoped=true&"
import script from "./ThinFemale.vue?vue&type=script&lang=js&"
export * from "./ThinFemale.vue?vue&type=script&lang=js&"
import style0 from "./ThinFemale.vue?vue&type=style&index=0&id=2a2fe5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2fe5ac",
  null
  
)

export default component.exports